import { createFileRoute } from "@tanstack/react-router";
import ProblemasEnMiTienda from "@/pages/ProblemasEnMiTienda";

// Nota SEO: title/description/og:*/twitter:*/canonical los emite <SEO />
// (Helmet, también en SSR) dentro de SolutionProgramPage. Declararlos también
// aquí duplicaba cada etiqueta en el HTML servido.
export const Route = createFileRoute("/problemas-en-mi-tienda")({
  component: ProblemasEnMiTienda,
});
